export default "{\n    \"noDataMessage\": \"No hay datos disponibles.\"\n}\n"